import axios from "axios";
import ConstantsList from '../appConfig';

const API_PATH = ConstantsList.API_EN_POINT + "/user-ext";

export const pagingUserAccount = (searchObject) => axios.post(API_PATH + "/paging-users", searchObject);

export const getUserAccountById = (userAccountId) => axios.get(API_PATH + "/get-by-id/" + userAccountId);

export const saveOrUpdateUserAccount = userAccount => axios.post(API_PATH + "/save-or-update", userAccount);

export const deleteUserAccount = userAccountId => axios.delete(API_PATH + '/mark-delete/' + userAccountId);

export const createUserKeyCloak = userAccount => axios.post(API_PATH + "/create-use-keycloak", userAccount);

export const removeUserAccount = userAccountId => axios.delete(API_PATH + `/delete-user-and-keycloak-user/${userAccountId}`)

export const createUserWithStaff = (staff) => axios.post(API_PATH + "/create-user-with-staff",staff)

export const createUserV4WithPatient = (staff) => axios.post(API_PATH + "/create-user-with-patient",staff)
